// Toggle responsive menu visibility when link clicked
document.addEventListener('DOMContentLoaded', function () {
  let navigation = document.querySelector('.rnk-Hero_Navigation'),
      navBarItems = navigation.querySelectorAll('.rnk-Hero_NavBarItem'),
      openClass = 'rnk-Hero_Navigation-open',
      navBarToggle = document.querySelector('.rnk-Hero_NavBarToggle')

  navBarToggle?.addEventListener('click', () => {
    navigation.classList.toggle(openClass)
  })

  navBarItems?.forEach(navBarItem => {
    navBarItem.addEventListener('click', () => {
      navigation.classList.remove(openClass)
    })
  })
})
